<template>
    <div class="layout-px-spacing">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active" aria-current="page">
                                    <span>Edit Violator's Details</span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">
            <div class="col-xl-10 col-lg-10 col-md-12 col-12 layout-spacing">
                <div class="panel br-4">
                    <div class="panel-body">
                        <router-link to="/violator/view">
                            <button type="button" class="btn btn-danger mb-2 me-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-arrow-left">
                                    <line x1="19" y1="12" x2="5" y2="12"></line>
                                    <polyline points="12 19 5 12 12 5"></polyline>
                                </svg>
                                Back to Violators
                            </button>
                        </router-link>
                        <h6>Edit Violator's Details</h6>

                        <!-- Form -->
                        <form @submit.prevent="updateViolator">
                            <div class="column">
                                <div class="col-md-12">
                                    <div class="mb-4">
                                        <label class="col-form-label" for="name">Violator's Name</label>
                                        <input v-model="employee.name" type="text" id="name" class="form-control"
                                            required />
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="position">Position</label>
                                        <input v-model="employee.position" type="text" id="position"
                                            class="form-control" required />
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="phone">Phone Number</label>
                                        <input v-model="employee.phone" type="text" id="phone" class="form-control"
                                            @input="validatePhone"
                                            :class="{'is-invalid': phoneError}" />
                                        <div v-if="phoneError" class="invalid-feedback">
                                            Phone number must be 255 characters or less
                                        </div>
                                    </div>
                                    <div class="mb-4">
                                        <label class="col-form-label" for="email">Email</label>
                                        <input v-model="employee.email" type="email" id="email" class="form-control" />
                                    </div>
                                </div>

                                <div class="text-center mt-3">
                                    <button type="submit" class="btn btn-success" :disabled="loading">
                                        {{ loading ? 'Processing...' : 'Update' }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useMeta } from "/src/composables/use-meta";
import axios from 'axios';
import { BASE_URL } from '/src/Config/config';

useMeta({ title: "Edit Violator's Details" });

const route = useRoute();
const router = useRouter();

const employee = ref({
    id: null,
    name: '',
    position: '',
    phone: '',
    email: ''
});

const loading = ref(false);
const phoneError = ref(false);

// Validate phone number length
const validatePhone = () => {
    phoneError.value = employee.value.phone?.length > 255;
};

// Fetch violator by ID
const loadViolator = async (id) => {
    try {
        loading.value = true;
        const response = await axios.get(`${BASE_URL}/employees/${id}`);
        employee.value = response.data;
    } catch (error) {
        console.error("Error fetching violator:", error);
        alert("Failed to load violator data");
        router.push('/violator/view');
    } finally {
        loading.value = false;
    }
};

// Update the violator
const updateViolator = async () => {
    // Validate phone first
    validatePhone();
    if (phoneError.value) return;

    try {
        loading.value = true;
        if (employee.value.id) {
            await axios.put(`${BASE_URL}/employees/${employee.value.id}`, employee.value);
            alert('Violator updated successfully!');
        } else {
            await axios.post(`${BASE_URL}/employees`, employee.value);
            alert('Violator created successfully!');
        }
        router.push('/violator/view');
    } catch (error) {
        console.error("Failed to update violator:", error);
        alert(error.response?.data?.message || "Something went wrong while updating.");
    } finally {
        loading.value = false;
    }
};

// On page load
onMounted(() => {
    const id = Number(route.params.id);
    if (id) {
        loadViolator(id);
    } else {
        router.push('/violator/view');
    }
});
</script>

<style scoped>
/* Add any custom styles here */
.invalid-feedback {
    color: #dc3545;
    font-size: 0.875em;
}
.is-invalid {
    border-color: #dc3545;
}
</style>